// src/getPoiType/index.ts
var CHANNEL_FOOD = ["10001"];
var CHANNEL_LANDMARK = ["xiecheng_scenery"];
var isFood = ({ channels, poi_type } = {}) => {
  return CHANNEL_FOOD.some((channel) => {
    var _a;
    return (_a = channels == null ? void 0 : channels[channel]) == null ? void 0 : _a.length;
  }) || poi_type === "100000" /* FOOD */;
};
var isLandmark = ({ channels, channel, poi_type } = {}) => {
  return CHANNEL_LANDMARK.some((channel2) => {
    var _a;
    return (_a = channels == null ? void 0 : channels[channel2]) == null ? void 0 : _a.length;
  }) || channel === "xiecheng_scenery" || poi_type === "220000" /* LANDMARK */;
};
var getPoiType = (poi = {}) => {
  return {
    isFood: isFood(poi),
    isLandmark: isLandmark(poi)
  };
};

// src/track/index.ts
import { getOmega } from "@didi/webx-js";
var trackError = (...args) => {
  getOmega((omega) => {
    omega == null ? void 0 : omega.trackError(...args);
  });
};
var trackErrorWithStack = (error, trackCode, ext) => {
  const { name, message, stack, ...otherProps } = error;
  trackError(
    "trip-service-utils__error",
    trackCode || null,
    `${name}: ${message}`,
    {
      stack,
      ...otherProps,
      ...ext
    }
  );
};

// src/parser/index.ts
var parser = {
  parse: function(jsonStr) {
    try {
      return JSON.parse(jsonStr);
    } catch (error) {
      trackErrorWithStack(error, "parser.parse", {
        originData: jsonStr
      });
      return null;
    }
  },
  stringify: function(obj) {
    try {
      return JSON.stringify(obj);
    } catch (error) {
      trackErrorWithStack(error, "parser.stringify", {
        originData: obj
      });
      return "";
    }
  }
};

// src/preloadImages/index.ts
var preloadImages = (urls) => {
  const images = [];
  const promises = urls.map((url) => {
    return new Promise((resolve, reject) => {
      if (__mpx_mode__ === "wx") {
        wx.getImageInfo({
          src: url,
          success: () => {
            images.push({ url, success: true });
            resolve();
          },
          fail: () => {
            images.push({ url, success: false });
            reject();
          }
        });
      } else {
        const img = new Image();
        img.onload = () => {
          images.push({ url, success: true });
          resolve();
        };
        img.onerror = () => {
          images.push({ url, success: false });
          reject();
        };
        img.src = url;
      }
    });
  });
  return Promise.allSettled(promises).then(() => images);
};
export {
  getPoiType,
  isFood,
  isLandmark,
  parser,
  preloadImages,
  trackError,
  trackErrorWithStack
};
